(function() {
'use strict';

angular
.module('TR')
.controller('ChildDestinations', ChildDestinations);

function ChildDestinations(urlUtils, destinationService, $location, currentDestination) {
    const cd = this;
    const limit = 6;
    let dest;

    const parsed = urlUtils.parse($location.url());
    parsed.qs = _.omit(parsed.qs, ['pi', 'pt']);
    parsed.qs.allDest = true;
    cd.allDestinationsUrl = urlUtils.stripLeadingSlash(urlUtils.format(parsed));
    cd.showAll = $location.search().allDest;

    function chunk(size, array) {
        return [].concat(...array.map(function(elem, i) {
            return i % size ? [] : [array.slice(i, i + size)];
        }));
    }

    cd.toggleShowAll = function(e) {
        e.preventDefault();
        e.stopPropagation();
        cd.showAll = !cd.showAll;
        getChildDestinations(dest);
    };

    function processResults(children) {
        cd.children = destinationService.sortByTitle(children).map(function(child) {
            const childPagePath = urlUtils.appendExistingQueryString(urlUtils.stripLeadingSlash(child.PagePath));
            const parsed = urlUtils.parse(childPagePath);
            parsed.qs = _.omit(parsed.qs, ['pi', 'pt', 'allDest']);
            child.PagePath = urlUtils.format(parsed);
            return child;
        });
        cd.show = cd.children.length > 0;
        cd.chunks = chunk(2, cd.children);
    }

    function getChildDestinations(d) {
        if (cd.showAll) {
            destinationService.getAllChildren(d).then(processResults);
        } else {
            destinationService.getTopChildren(limit, d).then(processResults);
        }
    }

    currentDestination.getCurrentDestination().then(function(d) {
        dest = d;
        getChildDestinations(d);
    });
}
})();
